module.exports = __webpack_public_path__ + "img/item11.2f4b24db.png";